import {
  Card,
  CardContent,
  Grid,
  Grow,
  Typography,
  useTheme,
} from '@mui/material';
import { useHistory } from 'react-router-dom';
import { CardsGridItem } from './cardsGrid';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const CardsGridSubmenu = ({
  cover,
  items,
}: {
  cover: CardsGridItem;
  items: CardsGridItem[];
}) => {
  const theme = useTheme();
  const history = useHistory();

  const handleNavigation = (newPath: string | undefined) => {
    if (newPath) {
      history.push(newPath);
    }
  };

  return (
    <Grid container spacing={{ xs: 2, md: 3 }} sx={{ p: 5 }}>
      <Grid item xs={12} sm={4} md={1.75} sx={{ display: 'flex', justifyContent: 'center' }}>
        <Grow mountOnEnter timeout={500} in>
          <Card
            variant="outlined"
            sx={{
              width: '100%',
              maxWidth: 250,
              border: `1px solid ${theme.palette.secondary.main}`,
              backgroundColor: theme.palette.primary.main,
              textAlign: 'center',
              py: 2.5,
              cursor: 'pointer',
              height: 200,
              boxShadow: 3,
            }}
            onClick={() => handleNavigation(cover.path)}
          >
            <CardContent>
              <cover.icon color="secondary" sx={{ fontSize: 47 }} />
              <ExpandLessIcon color="secondary" sx={{ fontSize: 32 }} />
            </CardContent>
          </Card>
        </Grow>
      </Grid>

      {items.map((item) => (
        <Grid
          item
          xs={12}
          sm={4}
          md={2}
          key={item.path ?? item.title}
          sx={{ display: 'flex', justifyContent: 'center' }}
        >
          <Grow mountOnEnter timeout={500} in>
            <Card
              variant="outlined"
              sx={{
                width: '100%',
                maxWidth: 330,
                border: `1px solid ${item.disabled ? 'gray' : theme.palette.secondary.main}`,
                textAlign: 'center',
                py: 2.5,
                cursor: 'pointer',
                height: 150,
                boxShadow: 3,
              }}
              onClick={() => handleNavigation(item.path)}
            >
              <CardContent>
                <item.icon
                  color={item.disabled ? 'disabled' : 'secondary'}
                  sx={{ fontSize: 47 }}
                />
                <Typography fontSize={12}>{item.title.toUpperCase()}</Typography>
              </CardContent>
            </Card>
          </Grow>
        </Grid>
      ))}
    </Grid>
  );
};

export default CardsGridSubmenu;
